import { z } from "zod/v4";

export const generateResponseSchema = z.object({
	exclusions_skipped: z.number().int(),
	sessions_created: z.number().int(),
	sessions_skipped: z.number().int(),
});

export const previewSessionSchema = z.object({
	date: z.string(),
	day_of_week: z.number().int().min(0).max(6),
	end_time: z.string(),
	group_id: z.string().uuid(),
	group_name: z.string(),
	slot_id: z.string().uuid(),
	start_time: z.string(),
});

export const generatePreviewResponseSchema = z.object({
	excluded: z.number().int(),
	sessions: z.array(previewSessionSchema),
	skipped: z.number().int(),
	total_new: z.number().int(),
});

export const sessionStatusSchema = z.enum(["scheduled", "cancelled", "completed"]);

export const trainingSessionSchema = z.object({
	attendee_count: z.number().int(),
	date: z.coerce.date(),
	end_time: z.coerce.date(),
	event_id: z.string().uuid(),
	group_color: z.string().nullable().optional(),
	group_id: z.string().uuid(),
	group_name: z.string(),
	slot_id: z.string().uuid(),
	start_time: z.coerce.date(),
	status: sessionStatusSchema,
});

export const paginatedSessionsSchema = z.object({
	items: z.array(trainingSessionSchema),
	limit: z.number(),
	offset: z.number(),
	total: z.number(),
});
